import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getCurrentUser, updateCurrentUser, type UpdateCurrentUserRequest } from '../api/usersApi';

const profileKey = ['users', 'me'] as const;

export function useProfile() {
  return useQuery({ queryKey: profileKey, queryFn: getCurrentUser });
}

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateCurrentUserRequest) => updateCurrentUser(data),
    onSuccess: (data) => qc.setQueryData(profileKey, data),
  });
}
